import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lk/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/lk/src/components/AllProviders/AllProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/app/lk/src/components/CookieConsent/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentRoot"] */ "/app/lk/src/components/CookieConsent/CookieConsentRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyScripts"] */ "/app/lk/src/components/CookieConsent/ThirdPartyScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HubspotTracker"] */ "/app/lk/src/components/HubspotTracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/lk/src/components/SnackbarProvider/SnackbarProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/lk/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/lk/src/app/[locale]/layout.module.scss");
